export const ExplorerType = {
  module: "module",
  social: "social",
};
